export const colors = {
    primaryColor:"#624AF5",
    secondaryColor:"#A433F6",
}